module.exports = __webpack_public_path__ + "img/btn-fix-1.418bc1e1.png";